package com.catbit.opinionpoll.core.exceptions

import io.ktor.http.*

data class HttpResponseException(
    val statusCode: HttpStatusCode,
    override val message: String
) : Throwable()
